module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/203-sahrawi-arab-democratic-republic-dcc6b4282f903fc882c51178a8f2f61d.svg";